import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const GUEST_NAV_ITEMS = [
  // { label: '강의', path: '/classes' },
  // { label: '요금제', path: '/pricing' },
  { label: '공지 사항', path: '/notice', match: ['/notice', '/notices'] },
  { label: '고객센터', path: '/support' },
  { label: '가입', path: '/register' },
];

const AUTHED_NAV_ITEMS = [
  // { label: '강의', path: '/classes' },
  // { label: '요금제', path: '/pricing' },
  { label: '공지 사항', path: '/notice', match: ['/notice', '/notices'] },
  { label: '고객센터', path: '/support' },
];

export default function LandingHeader({ active }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isAuthenticated =
    typeof window !== 'undefined' && !!sessionStorage.getItem('access_token');
  const navItems = isAuthenticated ? AUTHED_NAV_ITEMS : GUEST_NAV_ITEMS;

  const isActive = (item) => {
    if (active) return active === item.path;
    if (item.match) return item.match.some((p) => pathname.startsWith(p));
    return pathname === item.path;
  };

  // 라우트가 바뀌면 드로어 닫기
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  // 드로어 열림 동안: Escape 닫기 + body 스크롤 잠금
  useEffect(() => {
    if (!menuOpen) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [menuOpen]);

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <header className="landing-header">
      <button
        type="button"
        className="landing-header__logo"
        onClick={() => navigate('/')}
        aria-label="GrowFit 홈"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/Growfit_font_black.png`}
          alt="GrowFit"
          className="landing-header__logo-img"
        />
      </button>

      <button
        type="button"
        className="landing-header__burger"
        onClick={() => setMenuOpen(true)}
        aria-label="메뉴 열기"
        aria-expanded={menuOpen}
        aria-controls="landing-header-nav"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </button>

      <button
        type="button"
        className={`landing-header__backdrop${menuOpen ? ' is-open' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-label="메뉴 닫기"
        tabIndex={-1}
      />

      <nav
        id="landing-header-nav"
        className={`landing-header__nav${menuOpen ? ' is-open' : ''}`}
      >
        <button
          type="button"
          className="landing-header__close"
          onClick={() => setMenuOpen(false)}
          aria-label="메뉴 닫기"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
        {/* <button
          type="button"
          className="landing-header__station"
          onClick={() => navigate('/')}
          aria-label="그로우핏 스테이션"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/station_black.png`}
            alt="station"
            className="landing-header__station-img"
          />
        </button> */}

        {navItems.map((item) => (
          <button
            key={item.path}
            type="button"
            className={`landing-header__nav-btn${
              isActive(item) ? ' landing-header__nav-btn--active' : ''
            }`}
            onClick={() => go(item.path)}
          >
            {item.label}
          </button>
        ))}

        {isAuthenticated ? (
          <button
            type="button"
            className="landing-header__login"
            onClick={() => go('/user/home')}
          >
            홈
          </button>
        ) : (
          <button
            type="button"
            className="landing-header__login"
            onClick={() => go('/login')}
          >
            로그인
          </button>
        )}
      </nav>
    </header>
  );
}
